import { Deserializable } from '../../protocols/deserializable';
import { Menu } from '../../menu/dto/menu';
import { Size } from '../../shared/size';
import { DisplayOptions } from '../../shared/display-options';
import { DateUtils } from '../../../utils/date-utils';
import { Orderable } from '../../protocols/orderable';
import { Cachable } from '../../protocols/cachable';
import { HasId } from '../../protocols/has-id';

export class Display implements Deserializable, Cachable, Orderable, HasId {
  public id: string;
  public companyId: number;
  public locationId: number;
  public name: string;
  public url: string;
  public priority: number;
  public configurationIds: string[];
  public configurations: Menu[];
  public displaySize: Size;
  public options: DisplayOptions;
  public lastSession: number;
  // Cache
  public cachedTime: number;

  public onDeserialize() {
    this.configurationIds = Array.from(this.configurationIds || []);
    this.configurations = window.injector.Deserialize.arrayOf(Menu, this.configurations);
    this.displaySize = window.injector.Deserialize.instanceOf(Size, this.displaySize);
    this.options = window.injector.Deserialize.instanceOf(DisplayOptions, this.options);
  }

  static buildArrayCacheKey(companyId): string {
    return `Displays-${companyId}`;
  }

  static buildCacheKey(companyId, locationId: number, displayId: string): string {
    return `Display-${companyId}-${locationId}-${displayId}`;
  }

  cacheExpirySeconds(): number {
    return DateUtils.secondsInOneHour();
  }

  cacheKey(companyId: number): string {
    return Display.buildCacheKey(companyId, this.locationId, this.id);
  }

  isExpired(): boolean {
    const expiresAt = this.cachedTime + this.cacheExpirySeconds();
    return DateUtils.currentTimestampInSeconds() > expiresAt;
  }

  getOrderableTitle(): string {
    return this.name;
  }

  getOrderableUniqueId(): string {
    return this.id;
  }

  getOrderValue(): number {
    return this.priority;
  }

  setOrderableValue(val: number) {
    this.priority = val;
  }

  getId(): string {
    return this.id;
  }
}
